export const StatCard = ({ label, value, sub, accent = "text-white", testId }) => (
  <div className="rounded-xl border border-white/10 bg-[#0c0c0e] p-5" data-testid={testId}>
    <p className="label-tech text-[10px] text-neutral-500">{label}</p>
    <p className={`mt-2 font-display text-3xl font-extrabold tracking-tight ${accent}`}>
      {value ?? "—"}
    </p>
    {sub && <p className="mt-1 text-xs text-neutral-500">{sub}</p>}
  </div>
);

export const EmptyState = ({ title = "No data", hint }) => (
  <div className="rounded-xl border border-dashed border-white/15 bg-white/[0.02] p-10 text-center" data-testid="empty-state">
    <p className="font-display text-lg font-bold text-neutral-300">{title}</p>
    {hint && <p className="mx-auto mt-2 max-w-md text-sm text-neutral-500">{hint}</p>}
  </div>
);

export const PageTitle = ({ eyebrow, title, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <p className="label-tech text-[#FF3333]">{eyebrow}</p>
      <h1 className="mt-2 font-display text-3xl font-black tracking-tight text-white sm:text-4xl">{title}</h1>
    </div>
    {children}
  </div>
);

export const Pill = ({ tone = "neutral", children }) => {
  const tones = {
    neutral: "border-white/15 bg-white/5 text-neutral-300",
    green: "border-emerald-400/30 bg-emerald-400/10 text-emerald-300",
    red: "border-[#FF3333]/40 bg-[#FF3333]/10 text-[#FF7a7a]",
    cyan: "border-[#00F0FF]/30 bg-[#00F0FF]/10 text-[#00F0FF]",
    amber: "border-amber-400/30 bg-amber-400/10 text-amber-300",
  };
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${tones[tone]}`}>
      {children}
    </span>
  );
};

export const ActionButton = ({ tone = "neutral", children, ...props }) => {
  const tones = {
    neutral: "border-white/15 bg-white/5 text-neutral-200 hover:border-white/35",
    red: "border-[#FF3333]/40 bg-[#FF3333]/10 text-[#FF7a7a] hover:bg-[#FF3333]/20",
    cyan: "border-[#00F0FF]/30 bg-[#00F0FF]/10 text-[#00F0FF] hover:bg-[#00F0FF]/20",
  };
  return (
    <button
      className={`rounded-lg border px-3 py-1.5 text-xs font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white/30 disabled:opacity-50 ${tones[tone]}`}
      {...props}
    >
      {children}
    </button>
  );
};

export const Table = ({ head, children, testId }) => (
  <div className="overflow-x-auto rounded-xl border border-white/10" data-testid={testId}>
    <table className="w-full min-w-[720px] text-left text-sm">
      <thead>
        <tr className="border-b border-white/10 bg-white/[0.03]">
          {head.map((h) => (
            <th key={h} className="label-tech px-4 py-3 text-[10px] text-neutral-500">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-white/5">{children}</tbody>
    </table>
  </div>
);

export const cell = "px-4 py-3 text-neutral-300";
